/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { OrderListItem } from '@components/molecules'
import { OrderViewTab } from '@components/systems'

import { useAppSelector, ApiGetDataStatus } from '@redux/index'
import { OrderType } from '@schemas'
import { grey } from '@mui/material/colors'

interface PropsType {
	onDeleteClick: (anOrder: OrderType) => void
	onTabClick: (index: number) => void
}

export const OrderList = (props: PropsType) => {
	const orderList: OrderType[] = useAppSelector(state => state.order.orderList)
	const orderStatus: ApiGetDataStatus = useAppSelector(state => state.order.orderStatus)
	const selectedOrder: OrderType = useAppSelector(state => state.order.selectedOrder)
	const viewTabIndex: number = useAppSelector(state => state.order.viewTabIndex)

	const onDeleteClick = (anOrder: OrderType) => {
		props.onDeleteClick(anOrder)
	}

	return (
		<View css={style}>
			<OrderViewTab tabIndex={viewTabIndex} onTabClick={props.onTabClick} />

			<View className="listOuterView">
				{orderStatus === 'init' || orderStatus === 'loading' ? (
					<p>Loading...</p>
				) : (
					<View className="orderListView">
						{orderStatus === 'ok' ? (
							orderList.map(order => {
								const isSelected = order.id === selectedOrder.id
								return (
									<OrderListItem
										key={order.id}
										order={order}
										isSelected={isSelected}
										onDelete={() => onDeleteClick(order)}
									/>
								)
							})
						) : orderStatus === 'empty' ? (
							<p>주문 내역이 없습니다.</p>
						) : null}
					</View>
				)}
			</View>
		</View>
	)
}

const style = css({
	overflow: 'auto',
	height: '100%',

	'.listOuterView': {
		width: '100%',
		height: '100%',
		paddingTop: '5px',
		paddingBottom: '5px',
		border: '1px solid',
		borderColor: grey[300],
		borderRadius: '5px',
		backgroundColor: grey[50],
		overflowY: 'auto',
		padding: '0.5rem 1rem',
	},
})
